import builder from '../builder';
import PhoneHandTyping from '../../streamline-icons/bold/phone-hand-typing.svg';

export default builder('IconPhoneHandTypingBold', PhoneHandTyping);
